import React from 'react';
import { Typography } from '@kareo/design-system';
import { labStatusDisplay, LabOrderState, } from 'shared-assets/facesheet-ui/service/facesheet/types';
import { Grid, Box } from '@material-ui/core';
import FacesheetCardFooter from 'shared-assets/facesheet-ui/components/Facesheet/Card/FacesheetCardFooter';
import { StyledLabList } from 'shared-assets/facesheet-ui/utils/styledFacesheet';
import { getOrderedAtText } from 'shared-assets/facesheet-ui/utils/cardHelper';
import CachedDataWarning from '../Error/CachedDataWarning';
import { CACHED_DATA_MESSAGE } from '../../../service/patient/types';
function getLabOrderSummaries(data) {
    var listItems = data
        .filter(function (item) { return item.state != LabOrderState.ERROR; })
        .slice(0, 5)
        .map(function (item) {
        return (React.createElement("li", { key: item.orderedAt },
            React.createElement(Typography, { variant: "h4", component: "div" }, item === null || item === void 0 ? void 0 : item.subject),
            React.createElement(Typography, { display: "inline", color: "textSecondary" }, getOrderedAtText(item)),
            React.createElement(Typography, { display: "inline" }, " - " + labStatusDisplay[item.state])));
    });
    return listItems;
}
var LabsContent = function (_a) {
    var labsData = _a.labsData, cachedDate = _a.cachedDate;
    var labOrderSummaries = labsData ? labsData.labOrderSummaries : null;
    var listItems = labOrderSummaries
        ? getLabOrderSummaries(labOrderSummaries)
        : [];
    return (React.createElement(Grid, { container: true },
        cachedDate && (React.createElement(Box, { width: "100%", mb: 1.8 },
            React.createElement(CachedDataWarning, { messageType: CACHED_DATA_MESSAGE.WITH_DATE, lastCachedDate: cachedDate, displayBorder: true, addSuffix: true }))),
        listItems.length == 0 ? (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "body1", component: "div" }, "(None documented)"))) : (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(StyledLabList, null, listItems),
            React.createElement(FacesheetCardFooter, { text: "Displaying last " + listItems.length + " orders" })))));
};
export default LabsContent;
